import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { Autocomplete, Icon, TextField, IconButton } from "@mui/material";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 PRO React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataPaginateTable from "examples/Tables/DataPaginateTable";
import NotificationItem from "examples/Items/NotificationItem";

import React, { useEffect, useState } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import { useNavigate } from "react-router-dom";

import { URL_API } from "config";
import MDInput from "components/MDInput";
import { makeStyles } from "@material-ui/core/styles";
import { useAuthContext } from "context/AuthContext";

const useStyles = makeStyles((theme) => ({
  inputRoot: {
    '&[class*="MuiOutlinedInput-root"] .MuiAutocomplete-input:first-child': {
      padding: "3px",
      width: 148,
    },
  },
}));

function UserTable() {
  const classes = useStyles();

  const [companyResult, setCompanyResult] = useState([]);
  const [userResult, setUserResult] = useState([]);

  const [rowSelected, setRowSelected] = useState();

  const [tableLimit, setTableLimit] = useState(10);
  const [tablePage, setTablePage] = useState(1);
  const [tableTotal, setTableTotal] = useState(0);

  var [params, setParams] = useState();
  var [filter, setFilter] = useState();

  const navigate = useNavigate();

  const { user } = useAuthContext();

  let tag = localStorage.getItem("Tag");

  var dataTableData = {
    columns: [
      { Header: "Nome", accessor: "name", width: "20%" },
      { Header: "Email", accessor: "email" },
      { Header: "Companhia", accessor: "company_name", width: "25%" },
      { Header: "Termos de Uso", accessor: "termsOfUseDate", width: "30%" },
      { Header: "StatusCompanyUser", accessor: "status", width: "7%" },
      { Header: "UUID", accessor: "uuid" },
      { Header: "Ações", accessor: "action", width: "7%" },
    ],
    rows: userResult,
  };

  useEffect(() => {
    if (user?.profile !== 99) navigate('/admin/dashboard');

    getUsers(tablePage, tableLimit);
    getCompanies();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tablePage, tableLimit]);

  async function getUsers(page = 1, limit = 10) {
    await axios
      .get(
        URL_API +
        `/users?page=${page}&limit=${limit}` +
        `${params ? `&company_id=${params}` : ""}` +
        `${filter && params ? `&filter=${filter}` : ""}` +
        `${filter && !params ? `&filter=${filter}` : ""}`,
        {
          headers: {
            Authorization: `Bearer ${tag}`,
          },
        }
      )
      .then(function (response) {
        for (const data of response.data.data) {
          Object.assign(data, {
            termsOfUseDate: new Date(data.terms_of_use_date).toLocaleDateString(
              "pt-BR"
            ),
          });
        }

        setUserResult(response.data.data);
        setTableTotal(response?.data.meta?.total);
      })
      .catch((error) => {
        if (error?.status === 401) {
          localStorage.removeItem("Tag");
          navigate("/auth/login");
        } else {
          toast.error(error?.message);
        }
      });
  }

  async function getCompanies() {
    await axios
      .get(URL_API + "/companies?page=1&limit=500", {
        headers: {
          Authorization: `Bearer ${tag}`,
        },
      })
      .then(function (response) {
        setCompanyResult(response.data.data);
      })
      .catch(function (error) {
        if (error?.status === 401) {
          localStorage.removeItem("Tag");
          navigate("/auth/login");
        } else {
          toast.error(error?.message);
        }
      });
  }

  async function updateUser(user) {
    await axios
      .put(URL_API + `/user/${user.uuid}`, user, {
        headers: {
          Authorization: `Bearer ${tag}`,
        },
      })
      .then(() => { })
      .catch((error) => {
        if (error?.response?.status === 401) {
          localStorage.removeItem("Tag");
          navigate("/auth/login");
        } else {
          toast.error(error?.response?.data?.message);
        }
      });
    getUsers(tablePage, tableLimit);
  }

  async function onDisable(params) {
    params.status = 2;

    await updateUser(params);
  }

  async function onEnable(params) {
    params.status = 1;

    await updateUser(params);
  }

  return (
    <>
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox pt={2}>
              <MDBox
                p={3}
                lineHeight={1}
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <MDTypography variant="h5" fontWeight="medium">
                  Filtros para Usuários
                </MDTypography>
              </MDBox>
              <MDBox
                p={1}
                lineHeight={1}
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <Grid container>
                  {user?.profile === 99 && (
                    <>
                      <Grid item>
                        <Autocomplete
                          onClose={() => {
                            getUsers(tablePage, tableLimit);
                          }}
                          onChange={(event, value) => {
                            if (value !== null) {
                              setParams(value.uuid);
                            } else {
                              setParams();
                            }
                          }}
                          getOptionLabel={(companyResult) => companyResult.name}
                          classes={classes}
                          sx={{ marginBottom: 1 }}
                          options={companyResult}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              placeholder="Buscar companhias..."
                            />
                          )}
                        />
                      </Grid>
                      <MDBox p={1} />
                    </>
                  )}
                  <Grid item>
                    <MDInput
                      label="Buscar por usuários..."
                      onChange={async (event) => {
                        if (event.target.value) {
                          setFilter(event.target.value);
                        } else {
                          setFilter();
                        }
                      }}
                      size="large"
                    />
                  </Grid>
                  <MDBox p={1} pt={6} />
                  <Grid item>
                    <IconButton
                      onClick={async () => await getUsers(tablePage, tableLimit)}
                      sx={{
                        color: '#fff',
                        background: '#3f50b5',
                        borderRadius: '8px',
                        "&:hover": {
                          backgroundColor: "blue",
                        },
                      }}
                    >
                      <Icon>search</Icon>
                    </IconButton>
                  </Grid>
                </Grid>
              </MDBox>
            </MDBox>
          </Card>
          <MDBox pt={2}>
            <Card>
              <MDBox
                p={3}
                lineHeight={1}
                style={{ display: "flex", justifyContent: "space-between" }}
              >
                <MDTypography variant="h5" fontWeight="medium">
                  Usuários
                </MDTypography>
                <MDButton
                  color="light"
                  onClick={() => {
                    navigate("/admin/usuarios/criar");
                  }}
                >
                  Novo
                </MDButton>
              </MDBox>
              <DataPaginateTable
                entriesPerPage={{ defaultValue: tableLimit }}
                table={dataTableData}
                onRowSelected={setRowSelected}
                setTableLimit={setTableLimit}
                tableLimit={tableLimit}
                setTablePage={setTablePage}
                tablePage={tablePage}
                tableTotal={tableTotal}
              >
                <NotificationItem
                  onClick={() => {
                    navigate("/admin/usuarios/atualizar/" + rowSelected.original.uuid);
                  }}
                  icon={<Icon>create</Icon>}
                  title="Editar"
                />
                {rowSelected?.original?.status === 1 ? (
                  <NotificationItem
                    onClick={() => {
                      onDisable(rowSelected.original);
                      navigate("/admin/usuarios");
                    }}
                    icon={<Icon>block</Icon>}
                    title="Desativar"
                  />
                ) : (
                  <NotificationItem
                    onClick={() => {
                      onEnable(rowSelected.original);
                      navigate("/admin/usuarios");
                    }}
                    icon={<Icon>check</Icon>}
                    title="Ativar"
                  />
                )}
              </DataPaginateTable>
            </Card>
          </MDBox>
        </MDBox>
      </DashboardLayout>
      <ToastContainer />
    </>
  );
}

export default UserTable;
